import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {COLORS} from '../constants';
import {getLang} from '../selectors';
import Crumbs from './Crumbs';
import ContactForm from './ContactForm';

import {ContactPage as cps} from '../strings';
import {Crumbs as cs} from '../strings';


class ContactPage extends Component {

  componentDidMount() {
    window.scrollTo(0,0);
  }

  makeCrumbs() {
    const {lang} = this.props;

    const crumbs = [
      {
        label: cs.home[lang],
        link: '/home',
      },
      {
        label: cs.contact[lang],
      },
    ]

    return crumbs;
  }

  render() {
    const {
      lang,
    } = this.props;

    return(
      <div style={s.container} className="fade-in">
        <div style={s.crumbsContainer}>
          <Crumbs crumbs={this.makeCrumbs()} />
        </div>
        <div style={s.header}>
          <h1 style={s.title}>
            {cps.title[lang]}
          </h1>
          <p style={s.subtitle}>
            {cps.subtitle[lang]}
          </p>
        </div>

        <div style={s.content}>
          <ContactForm showTitle={false} />
        </div>
      </div>
    )
  }
}

const maxWidth = '800px';


const s = {
  container: {
    maxWidth,
    margin: 'auto',
    // padding: '0px 20px',
    // paddingTop: '20px',
    padding: '20px',
  },
  header: {
    //marginTop: '40px',
    marginBottom: '40px',
  },
  title: {
    fontSize: '200%',
    fontWeight: 'bold',
    marginBottom: '25px',
    color: COLORS.gray200,
  },
  subtitle: {
    color: COLORS.gray200,
    fontSize: '90%',
    maxWidth: '400px',
    lineHeight: '1.7',
  },
  content: {
    marginBottom: '300px',
  },
  crumbsContainer: {
    margin: '10px 0px 60px',
  },
}

const mapStateToProps = (state, ownProps) => {
  return {
    lang: getLang(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  }
}


let Connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactPage)

Connected = withRouter(Connected);
//Connected = (Connected);
export default Connected;



// WEBPACK FOOTER //
// ./src/main/ContactPage.js